import { takeEvery, put, call, select } from 'redux-saga/effects'
import {
  GET_LIGHT_ENTREPRENEURS,
  ADD_LIGHT_ENTREPRENEURS,
  REMOVE_LIGHT_ENTREPRENEURS,
  SET_FAVOURITE_ENTREPRENEURS
} from '../../constants/employer'
import { API_SERVER } from '../../constants'
import { apiManualPost } from '../../utils/employer/request'
import {
  getLightEntrepreneurs,
  getLightEntrepreneurSuccess,
  getLightEntrepreneursFailed,
  addLightEntrepreneursFailed,
  removeLightEntrepreneursFailed,
  setFavouriteEntrepreneursFailed,
  addLightEntrepreneurs,
  removeLightEntrepreneurs
} from '../../actions/employer'
import { getLoggedInEmail } from '../../selectors/employer/client.selector'

// Load entrepreneurs
function* getEntrepreneursSaga({ values }) {
  try {
    const url = `${API_SERVER}/GetLightEntrepreneursDetails`
    const email = yield select(getLoggedInEmail)
    const body = JSON.stringify({
      leofferedbyemail: values !== undefined ? values : email
    })
    const result = yield call(apiManualPost, url, body)
    let lightEntre = JSON.parse(result.data)
    const selectedLE =
      values !== undefined ? lightEntre.filter((el) => el.email === values) : []
    yield put(
      getLightEntrepreneurSuccess(!!result ? lightEntre : [], selectedLE[0])
    )
  } catch (error) {
    yield put(getLightEntrepreneursFailed(error))
  }
}

// Add light entrepreneurs
function* addLightEntrepreneursSaga({ values }) {
  try {
    const url = `${API_SERVER}/AddLightEntrepreneurs`
    const formValues = values
    const offeredbyemail = yield select(getLoggedInEmail)

    const body = JSON.stringify({
      email: formValues.email,
      leofferedbyemail: offeredbyemail
    })
    const resultAdd = yield call(apiManualPost, url, body)

    if (
      resultAdd.data === 'Light Entrepreneurs details are updated successfully'
    ) {
      // yield put(addLightEntrepreneursSuccess(resultAdd.data))

      // Update tabel grid after Add light entrepreneurs
      yield put(getLightEntrepreneurs())
    } else {
      // yield put(addLightEntrepreneursFailed(resultAdd.data))
      yield put(setFavouriteEntrepreneursFailed())
    }
  } catch (error) {
    yield put(addLightEntrepreneursFailed(error))
  }
}

// Remove light entrepreneurs
function* removeLightEntrepreneursSaga({ values }) {
  try {
    const url = `${API_SERVER}/RemoveLightEntrepreneursDetails`
    const offeredbyemail = yield select(getLoggedInEmail)

    const body = JSON.stringify({
      email: values,
      leofferedbyemail: offeredbyemail
    })
    const resultRemove = yield call(apiManualPost, url, body)

    if (
      resultRemove.data ===
      'Light Entrepreneurs details are updated successfully'
    ) {
      // yield put(removeLightEntrepreneursSuccess(resultRemove.data))

      // Update tabel grid after delete light entrepreneurs
      yield put(getLightEntrepreneurs())
    } else {
      // yield put(removeLightEntrepreneursFailed(resultRemove.data))
      yield put(setFavouriteEntrepreneursFailed())
    }
  } catch (error) {
    yield put(removeLightEntrepreneursFailed(error))
  }
}

function* setFavouriteEntrepreneursSaga({ values }) {
  try {
    if (!values.isFavorite) {
      yield put(addLightEntrepreneurs({ email: values.leEmail }))
    } else {
      yield put(removeLightEntrepreneurs(values.leEmail))
    }
    // const url = `${API_SERVER}/AddFavoriteLightEntrepreneurDetails`
    // const uuid = yield select(getUuid)

    // const body = JSON.stringify({
    //   uuid: uuid,
    //   favoriteLightEntrepreneurId: values.leId
    // })
    // const result = yield call(apiManualPost, url, body)

    // if (
    //   result.data === 'Added favorite light entrepreneur details successfully'
    // ) {
    //   yield put(getLightEntrepreneurs())
    // } else {
    //   yield put(
    //     setFavouriteEntrepreneursFailed({ isFavorite: values.isFavorite })
    //   )
    // }
  } catch (error) {
    yield put(
      setFavouriteEntrepreneursFailed({ isFavorite: values.isFavorite })
    )
  }
}

export function* watchGetEntrepreneursSaga() {
  yield takeEvery(GET_LIGHT_ENTREPRENEURS, getEntrepreneursSaga)
}

export function* watchAddLightEntrepreneursSaga() {
  yield takeEvery(ADD_LIGHT_ENTREPRENEURS, addLightEntrepreneursSaga)
}

export function* watchRemoveLightEntrepreneursSaga() {
  yield takeEvery(REMOVE_LIGHT_ENTREPRENEURS, removeLightEntrepreneursSaga)
}

export function* watchSetFavouriteEntrepreneursSaga() {
  yield takeEvery(SET_FAVOURITE_ENTREPRENEURS, setFavouriteEntrepreneursSaga)
}

// export function* watchPreviewContractSaga() {
//   yield takeEvery(PREVIEW_CONTRACT, previewContractSaga)
// }
// export function* watchSignAndSendContractSaga() {
//   yield takeEvery(SIGN_AND_SEND_CONTRACT, signAndSendContractSaga)
// }
